import React, {Component} from "react";
import {Button, message, Switch ,Input, Radio,Form,Icon,Select,Card,Modal, Drawer} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import {hasAuth} from "../../../utils/NHCore";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import NHFormItem from '../../common/NHFormItem';
import NHSelect from '../../common/NHSelect/index'
import css from './detail.css'
import EditForm from './EditForm.js';
import DockingModeTable from './dockingModetable'
import DrawerShowForm from './drawerShowForm';

class DetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      frameVisibleMap: {
        detailPageFlag: true, // 详情页面
        addFlag: false, //  添加页面
        updateFlag: false, //  编辑页面
        dockingParamFlag: false, //table页面
      },
      initData: [],
      showOperationBtn: false,   // 是否显示批量删除按钮
      showDelete: false,    // 控制是否显示删除按钮
      detailPageInitData:{},
      formInitData:{},
      dockingParamPageTitle: '',
      selectedDjfsid: [],    // 选中对接方式ID
      drawerShow:false,  //抽屉页面展示
      initPtcsData:[],    //初始平台参数
      initJfcsData:[],    //初始缴费参数
      djfsmc:'',      //对接方式名称
    };
  }

  componentDidMount() {
    this.checkAllData();
  }

  checkAllData =()=>{
    NHFetch(`api/zhxg-jfxt/onPay/getDockingData`, 'GET')
    .then(res => {
        if (res) {
          this.setState({ detailPageInitData:res.data })
        }
    })
  }

  // 设置当前显示页
  setCurrentPageShow = showFlagName => {
    let frameVisibleMap = this.state.frameVisibleMap;
    for (let name in frameVisibleMap) {
      if (name === showFlagName) {
        frameVisibleMap[name] = true;
      } else {
        frameVisibleMap[name] = false;
      }
    }
    this.setState({
      frameVisibleMap: frameVisibleMap
    });
  };

  // 面板返回按钮事件
  handleFrameClose = () => {
    this.setCurrentPageShow("detailPageFlag");
  };

  // 详情页删除按钮点击事件
  handleDeleteBtnClick = (e, djfsid) => {
    e.stopPropagation();
    NHConfirm(
      "是否确定删除这个项目地下的所有资格项？",
      () => {
        NHFetch(`api/zhxg-jfxt/onPay/${djfsid}/deleteDockingMode`, 'GET')
        .then(res => {
            if (res && res.code === 200) {
              message.success("删除操作成功！");
              this.checkAllData();
            }
          }
        );
      },
      "warn"
    );
  };

  // Add按钮点击事件
  handleAddBtnClick = () => {
    let frameVisibleMap = this.state.frameVisibleMap;
    frameVisibleMap['addFlag'] = true;
    this.setState({
      frameVisibleMap: frameVisibleMap
    });
  };

  // update按钮点击事件
  handleUpdateBtnClick = (e, djfsid) => {
    e.stopPropagation();
    let frameVisibleMap = this.state.frameVisibleMap;
    frameVisibleMap['updateFlag'] = true;
    NHFetch(`api/zhxg-jfxt/onPay/${djfsid}/getDockingMode`, 'GET')
      .then(res => {
          if (res) {
              this.setState({ 
                formInitData: res.data,
                frameVisibleMap: frameVisibleMap 
              });
          }
      })
  };

  handleEditBtnClick =(e, djfsid,djfsmc) =>{
      e.stopPropagation();
      NHFetch('/zxjfgl/selectPayParams','GET',{djfsid:djfsid}).then(res =>{
          if (res && res.data){
              let initData = res.data;
              this.setState({
                  drawerShow: true,
                  initPtcsData:initData['ptcs'],
                  initJfcsData:initData['jfcs'],
                  djfsmc:djfsmc
              })
          }
      })
  }

  // Add处理弹窗确定事件
  handleAddOkClick = () => {
    this.formModelRef.props.form.validateFields((err, values) => {
      if (!err) {
        NHFetch(`api/zhxg-jfxt/onPay/insertDockingMode`, 'POST',values)
        .then(res => {
            if (res && res.code === 200) {
                message.success("添加基础数据信息成功！");
                this.setCurrentPageShow("detailPageFlag");
                this.checkAllData();
            }
        })
      }
    });
  };

  // Update处理弹窗确定事件
  handleUpdateOkClick = () => {
    this.formModelRef.props.form.validateFields((err, values) => {
      if (!err) {
        values.djfsid=this.state.formInitData.DJFSID;
        NHFetch(`api/zhxg-jfxt/onPay/updateDockingMode`, 'POST',values)
        .then(res => {
            if (res && res.code === 200) {
                message.success("修改基础数据信息成功！");
                this.setCurrentPageShow("detailPageFlag");
                this.checkAllData();
            }
        })
      }
    });
  };

  // 设置资格项管理页标题
  setDockingParamPageTitle = (title) => {
    this.setState({
      dockingParamPageTitle: title
    })
  }

  // 设置分类id
  handleSetDjfsid = (value) => {
    this.setState({
      selectedDjfsid: value
    });
  }

  // 资格项管理页面关闭事件
  handleDockingParamPageClose = () => {
    this.handleDetailBtnClick();
    this.setCurrentPageShow('detailPageFlag');
  }

  //详情按钮点击事件
  handleDetailBtnClick = (djfsid,djfsmc) => {
    this.handleSetDjfsid(djfsid);
    this.setDockingParamPageTitle(djfsmc);
    this.setCurrentPageShow('dockingParamFlag');
  };

  handleDrawerBtnClick =(e)=>{
      e.preventDefault();
      this.drawerShowForm.props.form.validateFields((err, values) => {
          if (!err) {
              let formData = [];
              for (let key in values) {
                  let itemData = {};
                  itemData.djcszid = key;
                  let value = values[key];
                  if (value && typeof value === 'object') {
                      let v = value[value.length - 1];
                      if (v) {
                          if (v.hasOwnProperty('uuid') && v['uuid']) {
                              itemData.csz = v['uuid'];
                          } else {
                              itemData.csz = v;
                          }
                      }
                  } else {
                      itemData.csz = value;
                  }
                  formData.push(itemData);
              }
              if (values['qrcode']) {
                  NHFetch('front/zhxg-unauth/dynamic/save', 'POST', [values['qrcode']])
                      .then(res1 => {
                      })
              }
              NHFetch('/zxjfgl/updatePtcsz', 'POST', formData)
                  .then(res => {
                      if (res && res.code === 200) {
                          if(!values.zfts){
                              values.zfts="";
                          }
                          NHFetch('/zxjfgl/editJfcs','POST',values).then(res =>{
                              if (res && res.code === 200) {
                                  message.success("修改缴费参数成功！");
                                  this.setState({
                                      drawerShow:false,
                                  })
                              }else {
                                  message.error("修改缴费参数失败")
                              }
                          })
                      }else {
                          message.error("修改对接参数值失败")
                      }
                  })
          }
      })
  }

  handleCloseFrame=()=>{
    this.setState({
        drawerShow:false,
        initPtcsData:[],
        initJfcsData:[],
        djfsmc:'',
    })
  }

  render() {
    const { djfsmc,initPtcsData,initJfcsData,drawerShow } = this.state;
    const InitData = this.state.detailPageInitData ? this.state.detailPageInitData : {};
    return (
      <div className={css.main_right_content} style={{height:getSize().contentH - 12,overflow:"auto"}}>
        <div style={{ display: this.state.frameVisibleMap.detailPageFlag ? "block" : "none" }}>
        {Object.keys(InitData).length!=0?InitData.map(element => {
            return (
              <Card
                className={css.detail_card}
                style={{ width: "80%", margin: "auto", marginBottom: "2%" }}
                key={element.DJFSID}
                onClick={() => this.handleDetailBtnClick(element.DJFSID, element.DJFSMC)}
              >
                <h4 style={{ marginLeft: "2%", display: "inline", width:"30%" }}>
                  对接方式名称： {element.DJFSMC}
                </h4>
                <h4 style={{ marginLeft: "4%", display: "inline", width:"30%" }}>
                  是否需要同步按钮： {element.SFXYTBAN}
                </h4>
                <h4 style={{ marginLeft: "4%", display: "inline", width:"30%" }}>
                  是否需要记录订单： {element.SFXYJLDD}
                </h4>
                <br />
                <h4 style={{ marginLeft: "2%", display: "inline", width:"30%" }}>
                  对接方式描述： {element.DJFSMS}
                </h4>
                <br />
                  {hasAuth("zhxg_yxxt_zxjfgl_jffagl:editCs") &&<Icon type='form' className={css.updateIcon} onClick={(e)=>this.handleEditBtnClick(e,element.DJFSID,element.DJFSMC)} />}
                {hasAuth("zhxg_yxxt_zxjfgl_jffagl:update") &&
                <Icon type='edit' className={css.editIcon} onClick={(e) => this.handleUpdateBtnClick(e, element.DJFSID)} />}
                {hasAuth("zhxg_yxxt_zxjfgl_jffagl:delete") &&
                <Icon type='delete' className={css.deleteIcon} onClick={(e) => this.handleDeleteBtnClick(e, element.DJFSID)} />}
              </Card>
            );
          }):null}
          <div style={{ width: "80%", margin: "auto" }}>
            {hasAuth("zhxg_yxxt_zxjfgl_jffagl:add") &&
            <Button type="dashed" style={{ width: "100%" }} size="large" onClick={this.handleAddBtnClick} >
              <Icon type="plus" />
            </Button>}
          </div>
        </div>
        <Modal title="新增对接方式"
                visible={this.state.frameVisibleMap.addFlag} 
                destroyOnClose={true}
                onOk={this.handleAddOkClick} 
                onCancel={this.handleFrameClose}
                cancelText='取消'
                okText='确定'>
            <EditForm key={1} wrappedComponentRef={(form) => (this.formModelRef = form)} />
        </Modal>
        <Modal title="编辑对接方式" 
                visible={this.state.frameVisibleMap.updateFlag} 
                onOk={this.handleUpdateOkClick} 
                onCancel={this.handleFrameClose}
                cancelText='取消'
                okText='确定'>
            <EditForm key={2} wrappedComponentRef={(form) => (this.formModelRef = form)} editData={this.state.formInitData} />
        </Modal>
        <NHContainerFrame
          title={this.state.dockingParamPageTitle}
          visible={this.state.frameVisibleMap.dockingParamFlag}
          onOk={null}
          onCancel={this.handleDockingParamPageClose}
          style={{ padding: '16px 16px 16px 16px', background: '#fff' , height:'100%' }}
        >
          <DockingModeTable flushDetailPage={this.handleDetailBtnClick} djfsid={this.state.selectedDjfsid} />
        </NHContainerFrame>
          <Drawer
              className="evaluationDrawer"
              title={djfsmc + "参数设置"}
              visible={this.state.drawerShow}
              width={1000}
              destroyOnClose={true}
              onClose={this.handleCloseFrame}
          >
              <DrawerShowForm
                  wrappedComponentRef={(ele) => (this.drawerShowForm = ele)}
                  title={djfsmc + "参数设置"}
                  initPtcsData={initPtcsData}
                  initJfcsData={initJfcsData}
                  handleDrawerBtnClick={this.handleDrawerBtnClick}
              />
          </Drawer>

          }
      </div>
    );
  }
}
const Detail = Form.create()(DetailPage);
export default Detail;



// WEBPACK FOOTER //
// ./components/zxjfgl/jffagl/index.js